module.exports = __webpack_public_path__ + "static/img/sem-banner.304184a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sem-banner.jpg
// module id = eAmv
// module chunks = 1